export default __webpack_public_path__ + "static/media/UserIcon.06d61860.svg";